import React from 'react'
import BlackduckBinaryAnalysisCredentialsForm from './BlackduckBinaryAnalysisCredentialsForm'
import BlackduckBinaryAnalysisMappingForm from './BlackduckBinaryAnalysisMappingForm'
import GenericPullConfigListing from '../GenericPullConfigListing'

const BlackduckBinaryAnalysisConfigListing = (props) => {
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={BlackduckBinaryAnalysisMappingForm}
            CredentialsForm={BlackduckBinaryAnalysisCredentialsForm}
            componentName="Application"
            componentKey="groupAppName"
        />
    )
};

export default BlackduckBinaryAnalysisConfigListing;